<div class="dialog-header">
    <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form style="width: 100%" [formGroup]="form" (ngSubmit)="submitForm()">
    <h3 style="text-align: center">
        {{ !isNew ? this.name : "Agregar" }}
    </h3>
    <div class="container" style="margin: 20px;">
        <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
                <mat-form-field appearance="outline" class="w-100" [class.desactivado]="!isNew">
                    <mat-label>RUT</mat-label>
                    <input matInput formControlName="fullRut" (blur)="inputRut($event)"/>
                    <mat-spinner matSuffix diameter="20" *ngIf="isSearchingOwner"></mat-spinner>
                </mat-form-field>
            </div>
            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100" [class.desactivado]="!isNew || isSearchFoundOwner">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" type="text" />
                </mat-form-field>
            </div>
            <div *ngIf="this.relationType=='partner'" class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" type="text" />
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="this.relationType=='partner'" class="row">
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Participacion</mat-label>
                    <input type="number" matInput formControlName="participation" min="0" max="100" />
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Estado Civil</mat-label>
                    <input type="text" matInput formControlName="civilState" />
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Edad</mat-label>
                    <input type="number" matInput formControlName="age" />
                </mat-form-field>
            </div>
            <div class="col-md-12 check-section-type">
                <mat-checkbox formControlName="isAval">
                    AVAL
                </mat-checkbox>
                <mat-checkbox formControlName="isRL">
                    RL
                </mat-checkbox>
            </div>
            
        </div>
        <div *ngIf="this.relationType=='representative'" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Rol</mat-label>
                    <input matInput formControlName="role" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="phone" type="text" />
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="this.relationType=='otros'" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="description" type="text" />
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="relationType === 'partner'" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de escritura</mat-label>
                    <mat-select formControlName="deedDocumentType">
                        <mat-option value="">Sin escritura</mat-option>
                        <mat-option value="Empresa en un día">Empresa en un día</mat-option>
                        <mat-option value="Notaria">Notaria</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row" formGroupName="deedDocumentInfo">
            @if(deedDocumentType){            
                @if(deedDocumentType === 'Notaria') {
                    <div class="col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nombre Notaria</mat-label>
                            <input formControlName="notaryName" matInput type="text" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Dirección Notaria</mat-label>
                            <input formControlName="notaryAddress" matInput type="text" />
                        </mat-form-field>
                    </div>    
                }
                @if(deedDocumentType === 'Empresa en un día') {
                    <div class="col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Código Verificación</mat-label>
                            <input formControlName="deedCode" matInput type="text" />
                        </mat-form-field>
                    </div>
                }
            <div class="col-md-6 col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha escritura</mat-label>
                    <input formControlName="deedDate" matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>    
        }
        </div>
    </div>
    <section class="contenedor_boton">
        <button mat-flat-button color="primary" class="w-50" type="submit" [disabled]="this.form.invalid">
            {{ !isNew ? "Actualizar" : "Agregar" }}

        </button>
    </section>

    <ng-template #loading>
        <mat-spinner [diameter]="40"></mat-spinner>
    </ng-template>